import React, { useState, useEffect, useContext } from "react";
import { useForm } from "react-hook-form";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";
import { TextField, Fab, IconButton, Typography } from "@material-ui/core";
import { useStyles } from "../../../assets/styles";
import ButtonWithStyle from "../../../HOCs/ButtonWithStyle/ButtonWithStyle";
import { AuthContext } from "../../../AuthContext";
import CustomSelectNative from "../../CustomForms/CustomSelectNative/CustomSelectNative";
import { NEW, EDIT, DELETE } from "../CategoryAction/CategoryAction";
import { updateWithImage, editWithImage, deleteWithImage } from "./updateWithImage";

export default function AddCategoryForm(props) {
	const { handleProgress, handleLoading, returnAction, action } = props;
	const [background, setBackground] = useState("");
	const [categoriesArray, setCategoriesArray] = useState([]);
	const { register, handleSubmit, setValue } = useForm();
	const classes = useStyles();

	const {
		databasesRef: { parentMenuDB, nameDB },
	} = useContext(AuthContext);

	const onSubmit = (data) => {
		const params = { data, handleProgress, parentMenuDB, categoriesArray, handleLoading, nameDB };
		switch (action) {
			case NEW:
				updateWithImage(params);
				break;
			case EDIT:
				editWithImage(params);
				break;
			case DELETE:
				deleteWithImage(params);
				break;
			default:
				break;
		}
	};

	const handleImageSelector = (e) => {
		const { files } = e.target;
		const image = files[0];
		if (!image) return;
		const newValue = URL.createObjectURL(image);
		setBackground(newValue);
	};

	useEffect(() => {
		if (parentMenuDB) {
			const categoriesListener = parentMenuDB.onSnapshot((doc) => {
				setCategoriesArray(doc?.data()?.categories || []);
			});
			return categoriesListener;
		}
	}, [parentMenuDB]);

	const categoriesForEdit = [
		{ name: "Seleccionar", value: "", label: "Seleccionar" },
		...categoriesArray.map(({ name }) => ({ name, value: name, label: name })),
	];

	const handleOnChangeSelect = (e) => {
		const { value } = e.target;
		if (action !== EDIT || value === "") return;
		const { imgUrl, name } = categoriesArray.find(({ name }) => name === value);
		setBackground(imgUrl);
		setValue("name", name, { shouldValidate: true });
	};

	const renderSelect = (
		<CustomSelectNative
			options={categoriesForEdit}
			inputRef={register}
			id="category"
			name="category"
			fullWidth
			onChange={handleOnChangeSelect}
		/>
	);

	const renderForm = (
		<>
			<div
				style={{
					padding: "1em",
					backgroundImage: `url(${background})`,
					backgroundRepeat: "no-repeat",
					backgroundPosition: "center",
					margin: "1em 0",
				}}
			>
				<input
					accept="image/*"
					className={classes.inputFile}
					ref={register({ required: action !== EDIT })}
					name="imgUrl"
					id="imgUrl"
					type="file"
					onChange={handleImageSelector}
				/>
				<Fab>
					<label htmlFor="imgUrl">
						<IconButton color="primary" aria-label="upload picture" component="span">
							<AddPhotoAlternateIcon />
						</IconButton>
					</label>
				</Fab>
			</div>
			<Typography>Nombre de la categoria</Typography>
			<TextField fullWidth name="name" id="name" inputRef={register({ required: true })} />
			<Typography>Posicion de la categoria</Typography>
			<TextField fullWidth name="position" id="position" type="number" inputRef={register({ required: true })} />
		</>
	);

	return (
		<>
			<Typography variant="h5">{action}</Typography>
			<form onSubmit={handleSubmit(onSubmit)}>
				{action !== NEW && renderSelect}
				{action !== DELETE && renderForm}
				<ButtonWithStyle type="submit">{action === DELETE ? "Borrar" : "Guardar"}</ButtonWithStyle>
				<ButtonWithStyle onClick={returnAction}>Regresar</ButtonWithStyle>
			</form>
		</>
	);
}
